import { MessageCircle } from 'lucide-react';

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/905063859352"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      data-testid="whatsapp-btn"
      aria-label="WhatsApp"
    >
      <MessageCircle className="h-6 w-6 text-white" fill="white" />
    </a>
  );
}
